'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = createContextExtractor;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createContextExtractor(name) {
  return function (Field) {
    var FormFieldWrapper = function (_Component) {
      (0, _inherits3.default)(FormFieldWrapper, _Component);

      function FormFieldWrapper() {
        (0, _classCallCheck3.default)(this, FormFieldWrapper);
        return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
      }

      FormFieldWrapper.prototype.render = function render() {
        var _context = this.context,
            onionIsValid = _context.onionIsValid,
            onionFormName = _context.onionFormName,
            onionFieldRegister = _context.onionFieldRegister,
            onionLiveValidate = _context.onionLiveValidate,
            onionOnSubmit = _context.onionOnSubmit;


        return _react2.default.createElement(Field, (0, _extends3.default)({}, this.props, {
          onionIsValid: onionIsValid,
          onionFieldRegister: onionFieldRegister,
          onionFormName: onionFormName,
          onionLiveValidate: onionLiveValidate,
          onionOnSubmit: onionOnSubmit
        }));
      };

      return FormFieldWrapper;
    }(_react.Component);

    FormFieldWrapper.displayName = 'Form' + name + 'ContextExtractor';
    FormFieldWrapper.contextTypes = {
      onionIsValid: _propTypes2.default.func.isRequired,
      onionFieldRegister: _propTypes2.default.func.isRequired,
      onionFormName: _propTypes2.default.string.isRequired,
      onionLiveValidate: _propTypes2.default.func.isRequired,
      onionOnSubmit: _propTypes2.default.func.isRequired
    };


    return FormFieldWrapper;
  };
}
module.exports = exports['default'];